import Statistics from "../img/chart_pie.svg?react";
import Orgs from "../img/orgs.svg?react";
import Users from "../img/Users.svg?react";
import { FileBarChart, ClipboardListIcon, KeyIcon } from "lucide-react";

export const default_code = "999";

export const SideMenuLinks = [
  {
    text: "side_menu.analytics",
    link: "/home",
    icon: Statistics,
  },
  {
    text: "side_menu.orgs",
    link: "/orgs",
    icon: Orgs,
  },
  {
    text: "side_menu.users",
    link: "/users",
    icon: Users,
  },
  {
    text: "Surveys",
    link: "/surveys",
    icon: ClipboardListIcon,
  },
  {
    text: "API Keys",
    link: "/api",
    icon: KeyIcon,
  },
  {
    text: "API History",
    link: "/api-logs",
    icon: KeyIcon,
  },
  {
    text: "side_menu.mor",
    link: "/multi-report",
    icon: FileBarChart,
  },
];

export const SideMenuAdminsLinks = [
  {
    text: "side_menu.analytics",
    link: "/home",
    icon: Statistics,
  },
  {
    text: "side_menu.org",
    link: "/orgs",
    icon: Orgs,
  },
  {
    text: "side_menu.users",
    link: "/users",
    icon: Users,
  },
  {
    text: "API Keys",
    link: "/api",
    icon: KeyIcon,
  },
  {
    text: "API History",
    link: "/api-logs",
    icon: KeyIcon,
  },
];
